import { FC } from "react";
import styled from "styled-components";
import { NavBarProps } from "../../../types";
import Flex from "@/shared/globals/UiElements/Flex";
import { Section } from "@/shared/layout";
import BurgerMenu from "./BurgerMenu";
import SearchOverlay from "./SearchBar/SearchOverlay";
import { BurgerIcon2 } from "@/assets/Icons/BurgerIcon2";
import Logo from "@/templates/default/elements/Logo";
import FixedNav from "../../elements/FixedNav";

const MobileNavbar: FC<NavBarProps> = ({ menu, socialMedia }) => {
  return (
    <ShowBelowMobile>
      <Section boxShadow background="white">
        <StyledFlex alignItems="center" justifyContent="space-between">
          <BurgerMenu
            menus={menu!}
            socialSettings={socialMedia!}
            icon={<BurgerIcon2 />}
          />
          <Logo />
          <SearchOverlay />
        </StyledFlex>
      </Section>
      <FixedNav menus={menu!} socialSettings={socialMedia!} />
    </ShowBelowMobile>
  );
};

export default MobileNavbar;

/**
 *
 * Styles
 *
 */

const ShowBelowMobile = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

const StyledFlex = styled(Flex)`
  padding-block: 10px;
`;
